var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("transition", { attrs: { name: "vb-transition" } }, [
    !_vm.closed
      ? _c(
          "div",
          { staticClass: "vb-wrapper" },
          [
            _c("div", { class: _vm.classes }, [
              _c("div", { staticClass: "vb-header" }, [
                _c(
                  "div",
                  { staticClass: "vb-title", on: { click: _vm.maximize } },
                  [_vm._v(_vm._s(_vm.title))]
                ),
                _vm._v(" "),
                _c("div", { staticClass: "vb-buttons" }, [
                  _vm.concise && !_vm.maximized && !_vm.hideConciseButton
                    ? _c("i", {
                        staticClass: "fa fa-chevron-up",
                        attrs: { "aria-hidden": "true" },
                        on: {
                          click: function($event) {
                            _vm.concise = false
                          }
                        }
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  !_vm.concise && !_vm.maximized && !_vm.hideConciseButton
                    ? _c("i", {
                        staticClass: "fa fa-chevron-down",
                        attrs: { "aria-hidden": "true" },
                        on: {
                          click: function($event) {
                            _vm.concise = true
                          }
                        }
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.maximized
                    ? _c("i", {
                        staticClass: "fa fa-compress",
                        attrs: { "aria-hidden": "true" },
                        on: { click: _vm.minimize }
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  (_vm.showCloseWhenMaximized || !_vm.maximized) &&
                  !_vm.hideCloseButton
                    ? _c("i", {
                        staticClass: "fa fa-close",
                        attrs: { "aria-hidden": "true" },
                        on: { click: _vm.close }
                      })
                    : _vm._e()
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "vb-content" }, [
                _c(
                  "div",
                  { staticClass: "vb-content-slot" },
                  [_vm._t("default")],
                  2
                ),
                _vm._v(" "),
                !_vm.maximized
                  ? _c(
                      "div",
                      {
                        staticClass: "vb-minimized-overlay",
                        on: { click: _vm.maximize }
                      },
                      [
                        _c("i", {
                          staticClass: "fa fa-expand",
                          attrs: { "aria-hidden": "true" }
                        })
                      ]
                    )
                  : _vm._e()
              ])
            ]),
            _vm._v(" "),
            _c("transition", { attrs: { name: "vb-transition" } }, [
              _vm.maximized
                ? _c("div", {
                    staticClass: "vb-maximized-overlay",
                    on: { click: _vm.minimize }
                  })
                : _vm._e()
            ])
          ],
          1
        )
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-1d3d3d36", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1d3d3d36","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Balloon.vue
// module id = 8mh2
// module chunks = 0